import React from 'react';
import Hero from './Hero';
import Footer from '../Company/About/Footer';
import Home from '../Company/CompanyHome/Homev2';
import Navbar from '../Company/About/Navbar';
import Content from './Content';
import { Outlet } from 'react-router';
import { cn } from '@/lib/utils';

export default function UserAdmin() {
    return (
        <div className={cn("min-h-screen w-full bg-background flex flex-col")}>
            <Navbar />
            <Hero />
            <Content />
            {/* <Outlet /> */}
            <Footer />
        </div>
    );
}